jQuery( 'body' ).ready( function ( $ ) {
  if ( $( '.slider-img' ).length > 0 ) {
    $( '.slider-img' ).slick( {
      dots: true,
      slidesToShow: 1,
      infinite: true,
      autoplay: true,
      arrows: false,
      autoplaySpeed: 9000,
		});
	}

  if ( $( '.slider-img-mobile' ).length > 0 ) {
    $( '.slider-img-mobile' ).slick( {
      dots: true,
      slidesToShow: 1,
      infinite: true,
      autoplay: true,
      arrows: false,
      autoplaySpeed: 9000,
		});
	}

  if ($('.slider-fifth-section-mobile').length > 0) {
    $('.slider-fifth-section-mobile').slick({
      dots: true,
      arrows: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 4000,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
    });
	}

  if (document.getElementById('cafeto-why-cafeto')) {

    let wasIn = true;
    executeFirstCounter();

    /**
     * This function excute animation to each elements
     * @param {*} obj - DOM element
     * @param {*} start - Number where start counter
     * @param {*} end  - Number where end counter
     * @param {*} duration - Time to duration animation
     */
    function animateValue(obj, start, end, duration) {
        let startTimestamp = null;
        const step = (timestamp) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            obj.innerHTML = Math.floor(progress * (end - start) + start);
            if (progress < 1) {
                window.requestAnimationFrame(step);
            }
        };
        window.requestAnimationFrame(step);
    }

    /**
     * Validate if element is in user's viewport
     * @param {*} el - DOM element
     * @returns bool - before validation.
     */
    function elementInViewport(el) {
        var top = el.offsetTop;
        var left = el.offsetLeft;
        var width = el.offsetWidth;
        var height = el.offsetHeight;

        while (el.offsetParent) {
            el = el.offsetParent;
            top += el.offsetTop;
            left += el.offsetLeft;
        }

        return (
            top >= window.pageYOffset &&
            left >= window.pageXOffset &&
            (top + height) <= (window.pageYOffset + window.innerHeight) &&
            (left + width) <= (window.pageXOffset + window.innerWidth)
        );
    }

    /**
     * This function execute animation when user go in first time
     */
    function executeFirstCounter() {
        const elements = document.getElementsByClassName("Count");
        Array.prototype.forEach.call(elements, function (el) {
            let start = parseInt(el.getAttribute('data-value')) + 20;
            let end = parseInt(el.getAttribute('data-value'));
            animateValue(el, start, end, 2000);
        });
        wasIn = false;
    }

    /**
     * this function executeCounter always that scrooll is moving
     */
    function executeCounter() {
        const elementIndicators = document.getElementById("container-cards");
        const validateViewPort = elementInViewport(elementIndicators);

        if (!validateViewPort && !wasIn) {
            wasIn = true;
        }

        if (validateViewPort && wasIn) {
            const elements = document.getElementsByClassName("Count");
            Array.prototype.forEach.call(elements, function (el) {
                let start = parseInt(el.getAttribute('data-value')) + 20;
                let end = parseInt(el.getAttribute('data-value'));
                animateValue(el, start, end, 1000);
            });
            wasIn = false;
        }
    }

    window.addEventListener('scroll', function () {
        executeCounter();
    });

  }
});
